import React from 'react';
import { useSelector } from 'react-redux';

import AccountManagement from './AccountManagement';
import Authentication from './Authentication';
import AddSighting from './AddSighting';
import UserSightings from './UserSightings';
import VerifySightings from './VerifySightings';
import EditSighting from './EditSighting';
import EditUser from './EditUser';
import SightingFiltering from './SightingFiltering';

const Modal = props => {
  
  const modalProps = useSelector(store => store.modal);
        
  if (!modalProps.showModal) return false;

  return (
    <div className={ `modal-container ${ modalProps.isSuspended ? 'modal-container--suspended' : '' }` }>
      <div className="modal">        
        {
          modalProps.modalType === 'Authentication' &&
          <Authentication  />
        }

        {
          modalProps.modalType === 'AccountManagement' &&
          <AccountManagement />
        }

        {
          modalProps.modalType === 'AddSighting' &&
          <AddSighting />
        }

        {
          modalProps.modalType === 'UserSightings' &&
          <UserSightings />
        }

        {
          modalProps.modalType === 'VerifySightings' &&
          <VerifySightings />
        }

        {
          modalProps.modalType === 'EditSighting' &&
          <EditSighting />
        }

        {
          modalProps.modalType === 'EditUser' &&
          <EditUser />
        }

        {
          modalProps.modalType === 'SightingFiltering' &&
          <SightingFiltering map={ props.map } />
        }

    
      </div>
    </div>
  );

}

export default Modal;